import React from 'react';
import { Card } from '@drone-js/core';
import { FloatingSidePanelProps, mapStateToProps } from 'component/page/detail/FloatingSidePanel/FloatingSidePanel.selectors';
import { connect } from 'react-redux';
import SelectedOfferSummaryCard from 'component/page/detail/FloatingSidePanel/SelectedOfferSummaryCard';
import AvailableDetailPrice from 'component/page/detail/AvailableDetailPrice/AvailableDetailPrice';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesFloatingSidePanelSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { ActivitiesFloatingSidePanelSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';

const FloatingSidePanel: React.FC<FloatingSidePanelProps> = (props: FloatingSidePanelProps) => {
    const { selectedOffer } = props;
    const isOfferSelected = !!selectedOffer.offer;

    React.useEffect(() => {
        trackElementEvent<ActivitiesFloatingSidePanelSeenEventActivitiesFieldsV1>(ActivitiesFloatingSidePanelSeenEventActivitiesManifestV1.ids, {});
    }, []);

    const displayComponent = isOfferSelected ? <SelectedOfferSummaryCard /> : <AvailableDetailPrice.SidePanel />;

    return (
        <Card type="non-interactive" variant="elevation-m" width="100%" height="100%" data-element-name="activities-floating-side-panel" p="16">
            {displayComponent}
        </Card>
    );
};

FloatingSidePanel.displayName = 'FloatingSidePanel';

export default connect(mapStateToProps)(FloatingSidePanel);
